import React from "react";
import useStyles from "./styles";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import { Button } from "@material-ui/core";
import { Link } from 'react-router-dom';
import { Home as HomeIcon } from "@material-ui/icons";

export default function Home() {
  const classes = useStyles();

  return (
    <div className={classes.Btn}>
      <Link to="/app/home" style={{ textDecoration: "none" }}>
        <Button>
          <HomeIcon /> <h1>Home</h1>
        </Button>
      </Link>
    </div>
  );
}
